export const getCapacityItems = (store) => store.Filters.capacityValues || [];
